import * as Yup from 'yup';

const createRoundValidation = Yup.object().shape({
  title: Yup.string(),
  opened_at: Yup.string(),
  closed_at: Yup.string(),
});

export default createRoundValidation;
